// extracted by mini-css-extract-plugin
export default {"container":"_1n_GH4","contentWrapper":"_1FFJpf","content":"_3bwW99"};